import { addAtomDebugLabel } from '@ecomm/utils/addAtomDebugLabel'
import { atomWithStorage } from 'jotai/utils'

export const utmCodeStorageAtom = atomWithStorage<string | null>(
  'utm_code',
  null
)

addAtomDebugLabel(utmCodeStorageAtom, 'utm code')
